var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_10069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9277 3.92859V6.28573",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.928 9.82148C14.711 9.82148 14.5352 9.64559 14.5352 9.42862C14.5352 9.21166 14.711 9.03577 14.928 9.03577",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9277 9.82148C15.1447 9.82148 15.3206 9.64559 15.3206 9.42862C15.3206 9.21166 15.1447 9.03577 14.9277 9.03577",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0714 1C13.4043 1 11.8056 1.66224 10.6268 2.84104C9.44796 4.01985 8.78571 5.61863 8.78571 7.28571C8.79024 8.13817 8.96105 8.98154 9.28857 9.76857L8 12.7857L11.3629 12.3614C12.1644 12.9469 13.0932 13.3343 14.0732 13.4918C15.0532 13.6493 16.0566 13.5725 17.0013 13.2676C17.9459 12.9627 18.8048 12.4385 19.5079 11.7378C20.2109 11.037 20.738 10.1798 21.046 9.2362C21.354 8.29259 21.4341 7.28947 21.28 6.30893C21.1257 5.32839 20.7415 4.39831 20.1586 3.59485C19.5758 2.79138 18.811 2.13737 17.9267 1.68635C17.0425 1.23533 16.0641 1.00013 15.0714 1Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85658 0.785767H2.35658C1.48871 0.785767 0.785156 1.48932 0.785156 2.3572V19.6429C0.785156 20.5108 1.48871 21.2143 2.35658 21.2143H13.3566C14.2245 21.2143 14.928 20.5108 14.928 19.6429V16.5001",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07031 17.2858H8.64174",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_10069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsListIcon);
export default __webpack_public_path__ + "static/media/notificationsListIcon.4cc86798d664c3a377cda77b89468c11.svg";
export { ForwardRef as ReactComponent };